import { Injectable, Inject, Injector } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { UntypedFormGroup } from '@angular/forms';

import { LOCAL_STORAGE, StorageService, isStorageAvailable } from 'ngx-webstorage-service';

import { ExpiringCache } from '@app/models/expiringCache';

@Injectable({ providedIn: 'root' })
export class SharedUtilsService {
  // public phoneMask: any[] = [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  // public zipMask: any[] = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  // public minuteMask: any[] = [/^\d+$/];

  public phoneMask: string = '000-000-0000';
  public zipMask: string = '00000';
  public minuteMask: string = '0*';

  public previousRoute: string = '';
  public reloadCount = 0;

  public checkboxDropdownList = [{ label: '', value: null }, { label: 'Yes', value: true }, { label: 'No', value: false }];
  public activedownList = [{ label: 'Active', value: true }, { label: 'Inactive', value: false }];

  public stateAbbrList = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

  public statesList = [
    { full_name: 'Alabama', abbr: 'AL' },
    { full_name: 'Alaska', abbr: 'AK' },
    { full_name: 'Arizona', abbr: 'AZ' },
    { full_name: 'Arkansas', abbr: 'AR' },
    { full_name: 'California', abbr: 'CA' },
    { full_name: 'Colorado', abbr: 'CO' },
    { full_name: 'Connecticut', abbr: 'CT' },
    { full_name: 'Delaware', abbr: 'DE' },
    { full_name: 'District of Columbia', abbr: 'DC' },
    { full_name: 'Florida', abbr: 'FL' },
    { full_name: 'Georgia', abbr: 'GA' },
    { full_name: 'Hawaii', abbr: 'HI' },
    { full_name: 'Idaho', abbr: 'ID' },
    { full_name: 'Illinois', abbr: 'IL' },
    { full_name: 'Indiana', abbr: 'IN' },
    { full_name: 'Iowa', abbr: 'IA' },
    { full_name: 'Kansas', abbr: 'KS' },
    { full_name: 'Kentucky', abbr: 'KY' },
    { full_name: 'Louisiana', abbr: 'LA' },
    { full_name: 'Maine', abbr: 'ME' },
    { full_name: 'Maryland', abbr: 'MD' },
    { full_name: 'Massachusetts', abbr: 'MA' },
    { full_name: 'Michigan', abbr: 'MI' },
    { full_name: 'Minnesota', abbr: 'MN' },
    { full_name: 'Mississippi', abbr: 'MS' },
    { full_name: 'Missouri', abbr: 'MO' },
    { full_name: 'Montana', abbr: 'MT' },
    { full_name: 'Nebraska', abbr: 'NE' },
    { full_name: 'Nevada', abbr: 'NV' },
    { full_name: 'New Hampshire', abbr: 'NH' },
    { full_name: 'New Jersey', abbr: 'NJ' },
    { full_name: 'New Mexico', abbr: 'NM' },
    { full_name: 'New York', abbr: 'NY' },
    { full_name: 'North Carolina', abbr: 'NC' },
    { full_name: 'North Dakota', abbr: 'ND' },
    { full_name: 'Ohio', abbr: 'OH' },
    { full_name: 'Oklahoma', abbr: 'OK' },
    { full_name: 'Oregon', abbr: 'OR' },
    { full_name: 'Pennsylvania', abbr: 'PA' },
    { full_name: 'Rhode Island', abbr: 'RI' },
    { full_name: 'South Carolina', abbr: 'SC' },
    { full_name: 'South Dakota', abbr: 'SD' },
    { full_name: 'Tennessee', abbr: 'TN' },
    { full_name: 'Texas', abbr: 'TX' },
    { full_name: 'Utah', abbr: 'UT' },
    { full_name: 'Vermont', abbr: 'VT' },
    { full_name: 'Virginia', abbr: 'VA' },
    { full_name: 'Washington', abbr: 'WA' },
    { full_name: 'West Virginia', abbr: 'WV' },
    { full_name: 'Wisconsin', abbr: 'WI' },
    { full_name: 'Wyoming', abbr: 'WY' }
  ];

  public nonSupportedFiles = [
    'doc', 'docx', 'exe', 'html', 'htm', 'odt',
    'xls', 'xlsx', 'ods', 'ppt', 'pptx', 'txt'
  ];

  public dateRangeList = [
    { label: 'On or Before', value: 'Before' },
    { label: 'On or After', value: 'After' },
    { label: 'Between', value: 'Between' },
    { label: 'Last 30 Days', value: '-30' },
    { label: 'Last Week', value: '-7' },
    { label: 'Yesterday', value: '-1' },
    { label: 'Today', value: '0' },
    { label: 'Tomorrow', value: '1' },
    { label: 'Next Week', value: '7' },
    { label: 'Next 30 Days', value: '30' }
  ];

  public nonRangeList = [
    { label: 'Last 30 Days', value: '-30' },
    { label: 'Last Week', value: '-7' },
    { label: 'Yesterday', value: '-1' },
    { label: 'Today', value: '0' },
    { label: 'Tomorrow', value: '1' },
    { label: 'Next Week', value: '7' },
    { label: 'Next 30 Days', value: '30' }
  ];

  public nonFutureRangeList = [
    { label: 'On or Before', value: 'Before', weight: 1 },
    { label: 'On or After', value: 'After', weight: 2 },
    { label: 'Between', value: 'Between', weight: 3 },
    { label: 'Last 30 Days', value: '-30', weight: 4 },
    { label: 'Last Week', value: '-7', weight: 5 },
    { label: 'Yesterday', value: '-1', weight: 6 },
    { label: 'Today', value: '0', weight: 7 }
  ];

  public desktopNavMenu = [
    {
      fullMenu: true, parentLabel: null, key: 'search-jobs', label: 'Search Jobs', link: '/job-search', children: [
        {
          parentLabel: 'Search Jobs',
          key: 'speech-therapy',
          label: 'Speech Therapy',
          link: '/jobs/speech-language-pathologist',
          children: [
            {
              parentLabel: 'Speech Therapy',
              key: 'speech-language-pathologists',
              label: 'Speech Language Pathologists',
              link: '/jobs/speech-language-pathologist/',
              children: []
            },
            {
              parentLabel: 'Speech Therapy',
              key: 'speech-language-pathologist-assistants',
              label: 'Speech Language Pathologist Assistants',
              link: '/jobs/speech-language-pathologist-assistant',
              children: []
            }
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'occupational-therapy',
          label: 'Occupational Therapy',
          link: '/jobs/occupational-therapy',
          children: [
            {
              parentLabel: 'Occupational Therapy',
              key: 'occupational-therapist',
              label: 'Occupational Therapists',
              link: '/jobs/occupational-therapy',
              children: []
            }
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'school-nursing',
          label: 'School Nursing',
          link: '/jobs/registered-nurse',
          children: [
            {
              parentLabel: 'School Nursing',
              key: 'registered-nurse',
              label: 'Registered Nurse',
              link: '/jobs/registered-nurse',
              children: []
            },
            {
              parentLabel: 'School Nursing',
              key: 'license-practical-nurse',
              label: 'License Practical Nurse',
              link: '/jobs/licensed-practical-nurse',
              children: []
            }
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'behavior-analysis-support',
          label: 'Behavior Analysis & Support',
          link: '/jobs/school-psychologis',
          children: [
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'bcba',
              label: 'BCBA',
              link: '/jobs/bcba',
              children: []
            },
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'school-psychologist',
              label: 'School Psychologist',
              link: '/jobs/school-psychologist',
              children: []
            },
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'social-worker',
              label: 'School Social Worker',
              link: '/jobs/social-worker',
              children: []
            },
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'registered-behavior-technician',
              label: 'Registered Behavior Technician',
              link: '/jobs/registered-behavior-technician',
              children: []
            },
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'behavior-specialist',
              label: 'Behavior Specialist',
              link: '/jobs/behavior-specialist',
              children: []
            },
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'teachers',
          label: 'Teachers',
          link: '/jobs/special-education-teacher',
          children: [
            {
              parentLabel: 'Teachers',
              key: 'special-education-teacher',
              label: 'Special Education Teacher',
              link: '/jobs/special-education-teacher',
              children: []
            },
            {
              parentLabel: 'Teachers',
              key: 'dhh-teacher',
              label: 'DHH Teacher',
              link: '/jobs/dhh-teacher',
              children: []
            },
            {
              parentLabel: 'Teachers',
              key: 'adaptive-pe-teacher',
              label: 'Adaptive PE Teacher',
              link: '/jobs/adaptive-pe-teacher',
              children: []
            }
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'administration',
          label: 'Administration',
          link: '/jobs/special-education-teacher',
          children: [
            {
              parentLabel: 'Administration',
              key: 'special-education-directors',
              label: 'Special Education Director',
              link: '/jobs/special-education-teacher',
              children: []
            },
            {
              parentLabel: 'Administration',
              key: 'special-education-coordinators',
              label: 'Special Education Coordinator',
              link: '/jobs/special-education-coordinator',
              children: []
            }
          ]
        }    
      ]
    },
    { fullMenu: false, key: 'featured-locations', label: 'Featured Locations', link: '/featured-locations', children: []},
    {
      fullMenu: false, key: 'employer-services', label: 'Employer Resources', link: '/services', children: [
        {
          parentLabel: 'Employer Resources',
          key: 'our-services',
          label: 'Our Services',
          link: '/services',
          children: []
        },
        {
          parentLabel: 'Employer Resources',
          key: 'request-professionals',
          label: 'Request Professionals',
          link: '/request-professionals',
          children: []
        }        
      ]
    },
    {
      fullMenu: false, key: 'employee-services', label: 'Employee Resources', link: '#', children: [
        {
          parentLabel: 'Employee Resources',
          key: 'materials',
          label: 'Materials',
          link: '/materials',
          externalLink: false,
          children: []
        },
        {
          parentLabel: 'Employee Resources',
          key: 'our-services',
          label: 'Time Sheet Login',
          link: 'https://provida-online.teamkeeper.com/',
          externalLink: true,
          children: []
        },
        {
          parentLabel: 'Employee Resources',
          key: 'make-an-impact-fund',
          label: 'Make an Impact Fund',
          link: 'https://www.makeanimpactnow.org/corporate/edu-healthcare',
          externalLink: true,
          children: []
        },
        {
          parentLabel: 'Employee Resources',
          key: 'provider-perks',
          label: 'Provider Perks',
          link: 'https://providastaff.corporateperks.com/login',
          externalLink: true,
          children: []
        },
        {
          parentLabel: 'Employee Resources',
          key: 'check-stubs',
          label: 'Check Stubs',
          link: 'https://my.adp.com/static/redbox/',
          externalLink: true,
          children: []
        }, 

        {
          parentLabel: 'Employee Resources',
          key: 'benefits',
          label: 'Benefits',
          link: 'https://www.cigna.com/',
          externalLink: true,
          children: []
        }, 
        {
          parentLabel: 'Employee Resources',
          key: 'jumphire',
          label: 'JumpHire',
          link: 'https://www.jumphire.com/',
          externalLink: true,
          children: []
        },                                   
      ]
    },
    // { fullMenu: false, key: 'materials', label: 'Materials', link: '/materials', children: []},
    // { fullMenu: false, key: 'about-us', label: 'About Us', link: '/about-us', children: []},

    {
      fullMenu: false, key: 'about-us', label: 'About Us', link: '/about-us', children: [
        {
          parentLabel: 'About Us',
          key: 'our-story',
          label: 'Our Story',
          link: '/about-us/our-story',
          children: []
        },
        {
          parentLabel: 'About Us',
          key: 'what-makes-us-different',
          label: 'What Makes Us Different',
          link: '/about-us/what-makes-us-different',
          children: []
        },
      ]
    },

    { fullMenu: false, parentLabel: null, key: 'refer-a-friend', label: 'Refer a Friend', link: '/refer-a-friend', children: [] },
    { fullMenu: false, parentLabel: null, key: 'contact', label: 'Contact', link: '/contact-us', children: [] }
  ];

  public desktopNavMenuNew = [
    {
      fullMenu: true, parentLabel: null, key: 'search-jobs', label: 'Search Jobs', link: '/job-search', children: [
        {
          parentLabel: 'Search Jobs',
          key: 'speech-therapy',
          label: 'Speech Therapy',
          link: '/search-jobs/speech-therapy',
          children: [
            {
              parentLabel: 'Speech Therapy',
              key: 'speech-language-pathologists',
              label: 'Speech Language Pathologists',
              link: '/jobs/speech-language-pathologist',
              children: []
            },
            {
              parentLabel: 'Speech Therapy',
              key: 'speech-language-pathologist-assistants',
              label: 'Speech Language Pathologist Assistants',
              link: '/job-search',
              children: []
            }
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'occupational-therapy',
          label: 'Occupational Therapy',
          link: '/search-jobs/occupational-therapy',
          children: [
            {
              parentLabel: 'Occupational Therapy',
              key: 'speech-language-pathologists',
              label: 'Occupational Therapists',
              link: '/jobs/speech-language-pathologist',
              children: []
            },
            {
              parentLabel: 'Occupational Therapy',
              key: 'certified-occupational-therapist-assistants',
              label: 'Certified Occupational Therapist Assistants',
              link: '/job-search/certified-occupational-therapist-assistants',
              children: []
            }
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'school-nursing',
          label: 'School Nursing',
          link: '/search-jobs/school-nursing',
          children: [
            {
              parentLabel: 'School Nursing',
              key: 'speech-language-pathologists',
              label: 'Registered Nurse',
              link: '/jobs/speech-language-pathologist',
              children: []
            },
            {
              parentLabel: 'School Nursing',
              key: 'license-practical-nurse',
              label: 'License Practical Nurse',
              link: '/job-search/license-practical-nurse',
              children: []
            }
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'behavior-analysis-support',
          label: 'Behavior Analysis & Support',
          link: '/search-jobs/behavior-analysis-support',
          children: [
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'bcba',
              label: 'BCBA',
              link: '/jobs/bcba',
              children: []
            },
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'school-psychologist',
              label: 'School Psychologist',
              link: '/job-search/school-psychologist',
              children: []
            },
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'social-worker',
              label: 'School Social Worker',
              link: '/jobs/social-worker',
              children: []
            },
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'registered-behavior-technicians',
              label: 'Registered Behavior Technicians',
              link: '/jobs/registered-behavior-technicians',
              children: []
            },
            {
              parentLabel: 'Behavior Analysis & Support',
              key: 'behavior-interventionist',
              label: 'Behavior Interventionist',
              link: '/jobs/behavior-interventionist',
              children: []
            },
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'teachers',
          label: 'Teachers',
          link: '/search-jobs/teachers',
          children: [
            {
              parentLabel: 'Teachers',
              key: 'special-education-teachers',
              label: 'Special Education Teachers',
              link: '/jobs/special-education-teachers',
              children: []
            },
            {
              parentLabel: 'Teachers',
              key: 'dhh-teachers',
              label: 'DHH Teachers',
              link: '/job-search/dhh-teachers',
              children: []
            },
            {
              parentLabel: 'Teachers',
              key: 'adaptive-pe-teachers',
              label: 'Adaptive PE Teachers',
              link: '/job-search/adaptive-pe-teachers',
              children: []
            }
          ]
        },
        {
          parentLabel: 'Search Jobs',
          key: 'administration',
          label: 'Administration',
          link: '/search-jobs/administration',
          children: [
            {
              parentLabel: 'Administration',
              key: 'special-education-directors',
              label: 'Special Education Directors',
              link: '/jobs/special-education-directors',
              children: []
            },
            {
              parentLabel: 'Administration',
              key: 'special-education-coordinators',
              label: 'Special Education Coordinators',
              link: '/job-search/special-education-coordinators',
              children: []
            }
          ]
        }
      ]
    },
    { fullMenu: true, parentLabel: null, key: 'school-districts', label: 'School Districts', link: '', children: [] },
    {
      fullMenu: false, key: 'resource-center', label: 'Resource Center', link: '/materials', children: [
        {
          parentLabel: 'Resource Center',
          key: 'how-to-get-started',
          label: 'How To Get Started',
          link: '/resource-center/how-to-get-started',
          children: []
        },
        {
          parentLabel: 'Resource Center',
          key: 'student-new-grad-resources',
          label: 'Student & New Grad Resources',
          link: '/resource-center/student-new-grad-resources',
          children: []
        },
        {
          parentLabel: 'Resource Center',
          key: 'new-grad-mentorship-program',
          label: 'New Graduate Mentorship Program',
          link: '/resource-center/new-grad-mentorship-program',
          children: []
        },
        {
          parentLabel: 'Resource Center',
          key: 'school-materials',
          label: 'School Materials',
          link: '/resource-center/school-materials',
          children: []
        },

        {
          parentLabel: 'Resource Center',
          key: 'licensure-by-state',
          label: 'Licensure By State',
          link: '/resource-center/licensure-by-state',
          children: []
        },
        {
          parentLabel: 'Resource Center',
          key: 'professional-associations',
          label: 'Professional Associations',
          link: '/resource-center/professional-associations',
          children: []
        }
      ]
    },
    {
      fullMenu: false, key: 'about-us', label: 'About Us', link: '/about-us', children: [
        {
          parentLabel: 'About Us',
          key: 'our-story',
          label: 'Our Story',
          link: '/about-us/our-story',
          children: []
        },
        {
          parentLabel: 'About Us',
          key: 'what-makes-us-different',
          label: 'What Makes Us Different',
          link: '/about-us/what-makes-us-different',
          children: []
        },
      ]
    },

    { fullMenu: false, parentLabel: null, key: 'refer-a-friend', label: 'Refer a Friend', link: '', children: [] },
    { fullMenu: false, parentLabel: null, key: 'contact', label: 'Contact', link: '/contact-us', children: [] }
  ];

  // these date fields will trigger the date picker to show
  public datePickerFieldsList = ['Before', 'After', 'Between'];
  public focusFilterValues = [];

  constructor(
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private router: Router,
    private injector: Injector
  ) { }


  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  dropdownIdCompareFn(c1: Object, c2: Object): boolean {
    return c1 && c2 ? c1['_id'] === c2['_id'] : c1 === c2;
  }


  sleepFor(ms: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  }


  showStringAsTime(timeString) {
    if (!timeString) {
      return '';
    }

    const timeParts = timeString.split(':');

    let hour = parseInt(timeParts[0]);
    const minutes = timeParts[1];
    let amPm = 'AM';

    if (hour >= 12) {
      amPm = 'PM';
    }

    if (hour > 12) {
      hour -= 12;
    }

    return `${hour}:${minutes} ${amPm}`;
  }


  reloadComponentByRoute(_route: string) {
    this.previousRoute = _route;
    // this.router.navigateByUrl('/home', {skipLocationChange: true}).then(() => this.router.navigateByUrl(_route));
  }


  reloadComponentByRouteWithExtras(_route: string, _extras) {
    const navigationExtras: NavigationExtras = {
      state: {
        data: _extras
      }
    };

    this.router.navigateByUrl('/home', { skipLocationChange: true }).then(() => {
      this.router.navigate([_route], navigationExtras);
    });
  }


  reloadComponent(_route?: string) {
    const currentUrl = _route ?? this.router.url;
    this.router.navigateByUrl('/home', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }


  convertToMilitaryTime(timeString) {
    if (!timeString || (!timeString.toLowerCase().includes('am') && !timeString.toLowerCase().includes('pm'))) {
      return timeString;
    }

    const timeAmPmParts = timeString.split(' ');
    const timeParts = timeAmPmParts[0].split(':');
    const amPmPart = timeAmPmParts[1];
    let hour = timeParts[0];
    const minutes = timeParts[1];

    if (amPmPart.toLowerCase() === 'pm') {
      hour = parseInt(hour) + 12;
    } else {
      hour = '0' + hour;
    }

    return `${hour}:${minutes}`;
  }


  showStringAsTimeNoAmPm(timeString) {
    if (!timeString) {
      return '';
    }

    const timeParts = timeString.split(':');

    let hour = parseInt(timeParts[0]);
    const minutes = timeParts[1];
    let amPm = 'AM';

    if (hour >= 12) {
      amPm = 'PM';
    }

    if (hour > 12) {
      hour -= 12;
    }

    let returnString = `${hour}:${minutes} ${amPm}`;

    if (timeString.toLowerCase().includes('am') || timeString.toLowerCase().includes('pm')) {
      returnString = `${hour}:${minutes}`;
    }

    return returnString;
  }


  /** 
   * Used to get changes between objects. Can use for Activity Log (AUDIT) as well as user profile changes. 
   * * a is original object, b is object to look for changes in
  */
  getDiff(a, b) {
    // console.log('Checking for differences between..');
    // console.log('a: ', a);
    // console.log('b: ', b);

    const changesDetected = [];

    for (let prop in b) {
      const fieldDefs = { name: prop, value: '' };

      // console.log('Checking if prop is the same: ', prop);
      // console.log('A: ', a[prop]);
      // console.log('B: ', b[prop]);

      if (typeof b[prop] == 'undefined') {
        // this field has been removed from array b
        fieldDefs.value = 'REMOVED';
        changesDetected.push(fieldDefs);
      }
      else if (typeof a[prop] == 'undefined') {
        // this field was not in the original array. Has the field been added since?
        fieldDefs.value = b[prop];
        changesDetected.push(fieldDefs);
      }
      else if (JSON.stringify(a[prop]) !== JSON.stringify(b[prop])) {
        // Field change detected for prop: ', prop);
        fieldDefs.value = b[prop];
        changesDetected.push(fieldDefs);
      }
    }

    return changesDetected;
  }



  showInvalidFormMessage(_form: UntypedFormGroup) {
    for (let _control in _form.controls) {
      if (_form.controls[_control].status === 'INVALID') {
        this.showErrorDialog(_control + ' is Invalid. Cannot save.')
      }
    }
  }


  /** 
   * Takes a string passed in and returns the string with the first character uppercased
  */
  upperCaseFirstCharacter(_stringToTransform: string) {
    if (_stringToTransform) {
      return _stringToTransform.charAt(0).toUpperCase() + _stringToTransform.slice(1);
    } else {
      return '';
    }
  }


  /**
   * Takes a string passed in and displays a custom popup in notification fashion for 10 seconds
  */
  async showNotification(_notificationMessage: string) {
    const [{ MatSnackBar }, { EduNotificationComponent }] = await Promise.all([
      import('@angular/material/snack-bar'),
      import('@app/components/shared/notifications/edu-notification/edu-notification.component'),
    ]);
    this.injector.get(MatSnackBar).openFromComponent(EduNotificationComponent, {
      duration: 10000,
      data: {
        class: 'success',
        message: _notificationMessage
      }
    });
  }


  async showErrorDialog(_errorMessage: string, _duration: number = 1000) {
    const [{ MatSnackBar }, { EduNotificationComponent }] = await Promise.all([
      import('@angular/material/snack-bar'),
      import('@app/components/shared/notifications/edu-notification/edu-notification.component'),
    ]);
    this.injector.get(MatSnackBar).openFromComponent(EduNotificationComponent, {
      duration: _duration,
      data: {
        class: 'danger',
        message: 'Error: ' + _errorMessage
      }
    });
  }


  /**
   * Shows custom snackbar notification. Accepts string to show, a duration of milliseconds to show for, and a class to apply to the notification text
  */
  async showEduNotificationWithOptions(_dialogMessage: string, _duration: number = 3000, _className: string = 'primary') {
    const [{ MatSnackBar }, { EduNotificationComponent }] = await Promise.all([
      import('@angular/material/snack-bar'),
      import('@app/components/shared/notifications/edu-notification/edu-notification.component'),
    ]);
    this.injector.get(MatSnackBar).openFromComponent(EduNotificationComponent, {
      duration: _duration,
      data: {
        class: _className,
        message: _dialogMessage
      }
    });
  }


  /** 
   * Used for storing cacheable data. Pass in number of minutes you want an item to expire in. Returns time in milliseconds
  */
  getNewExpiresTime(_expireMinutes: number): number {
    const expirationMS = _expireMinutes * 60 * 1000; // 1000 (1 second) * 60 = 1 minute. Multiply by number of minutes we want
    return new Date().getTime() + expirationMS;
  }


  clearKeyFromLocal(key) {
    this.storage.remove(key);
  }


  // used for storing cacheable data
  isStorageValid(_storageItem): boolean {
    let isValid = false;

    if (_storageItem && _storageItem.itemCache && new Date().getTime() < _storageItem.expiresAt) {
      isValid = true;
    }

    return isValid;
  }


  updateStorageExpiration(_storageItem): ExpiringCache {
    // const district = this._districtService.getCurrentDistrictBeingViewed();
    // console.log('Will save with district of: ', district);

    _storageItem.expiresAt = this.getNewExpiresTime(15); // store data for 15 minutes before refreshing

    return _storageItem;
  }


  dateAsString(_date: Date) {
    return (_date.getMonth() + 1) + "-" + _date.getDate() + "-" + _date.getFullYear();
  }


  /** 
   * Used for storing objects in local storage. Will assign as key passed in
  */
  saveInLocal(_key: string, _object: any): void {
    // console.log('Saving value for: ', _key);
    // console.log('Object being stored: ', _object);

    try {
      this.storage.set(_key, JSON.stringify(_object));
      // localStorage.setItem(_key, JSON.stringify(_object));
    }
    catch (e) {
      console.log("Local Storage is full, Please empty data");
      console.log(e);
      // fires When localstorage gets full
      // you can handle error here or empty the local storage

      // const storageSize = Math.round(JSON.stringify(localStorage).length / 1024);
      // console.log("LIMIT REACHED: " + storageSize + "K");

      this.storage.clear();
    }
  }


  /** 
   * Used for retrieving object from local storage based on key passed in
  */
  getFromLocal(_key: string) {
    const storageAvailable = isStorageAvailable(localStorage);
    // console.log('Storage Available: ', storageAvailable);

    if (storageAvailable) {
      const recordCheck = this.storage.get(_key);
      // const recordCheck = localStorage.getItem(_key);
      if (!recordCheck) return null;

      return JSON.parse(recordCheck);
    } else {
      console.error('Storage service is undefined!');  // Debugging log
      return null;
    }
  }


  /** 
   * Used to see if a value is a type of Array
  */
  isArray(value) {
    let isTypeArray = false;
    if (value && typeof value === 'object' && value.constructor === Array) isTypeArray = true;
    return isTypeArray;
  }


  deepClone(obj) {
    if (obj === null || obj === undefined || typeof obj !== 'object') return obj; // Just return the object itself.
    if (obj instanceof Date) return new Date(obj.getTime());  // Handle Date objects specifically. Clone the Date object by copying its time.

    // Create an array or object to hold value.
    const newObject = Array.isArray(obj) ? [] : {};

    for (let key in obj) {
      const value = obj[key];
      // Recursive call for nested objects & arrays.
      newObject[key] = this.deepClone(value);
    }

    return newObject;
  }


  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}